export default "__VITE_ASSET__C3amk8Ce__"